<template>
  <div>
    <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
        <div>
            <b-nav id="mobileNavBarDispositivi" class="mobile-sub-nav fixed-top scrollable">
                <div>
                    <b-link href="#" @click="mostraPaginaCentrali" :class="{current: this.devicesType == '' || this.devicesType == null}">{{$t("navbar_dispositivi.all")}}</b-link>
<!-- @click="$bvModal.show('modal-device-type')" -->
                    <b-link  v-if="this.$store.getters.isCentralized" 
                      href="#"
                      v-b-toggle.sidebar-device-type
                      :class="{ current: ['illuminazione', 'emergenza', 'sensori'].includes(this.devicesType) }"
                    >
                      {{ selectedDeviceTypeText }}
                      <i class="fa fa-chevron-down small ml-1"></i>
                    </b-link>
                    
                    <!-- <b-link v-if="this.$store.getters.isCentralized && haIlluminazione()" href="#" @click="mostraPaginaIlluminazione" :class="{current: this.devicesType == 'illuminazione'}">{{$t("navbar_dispositivi.lighting")}}</b-link>
                    <b-link v-if="this.$store.getters.isCentralized && haIlluminazione()" href="#" @click="mostraPaginaEmergenza" :class="{current: this.devicesType == 'emergenza'}">{{$t("navbar_dispositivi.emergency")}}</b-link>
                    <b-link v-if="this.$store.getters.isCentralized && haIlluminazione()" href="#" @click="mostraPaginaSensori" :class="{current: this.devicesType == 'sensori'}">{{$t("navbar_dispositivi.sensor")}}</b-link> -->
                    <b-link v-if="this.$store.getters.isCentralized && haIlluminazione() && $store.state.showDevFeatures == true" href="#" @click="mostraPaginaCollection" :class="{current: this.devicesType == 'Aggregazioni'}">{{$t("navbar_dispositivi.collection")}}</b-link>
                    <b-link href="#" @click="mostraZoneBluetooth" :class="{current: this.devicesType == 'zoneBluetooth'}">{{$t("navbar_dispositivi.ble_zones")}}</b-link>
                    <b-link v-if="$store.state.showDevFeatures == true" href="#" @click="mostraPaginaLampadeQr" :class="{current: this.devicesType == 'QrLamps'}">{{$t("navbar_dispositivi.qrLamps")}}</b-link>
                </div>
            </b-nav>
        </div>
    </hide-at>
    <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
      <nav class="pl-3 pt-1 fixed-top navbar-illum">
        <b-button 
          :pressed="btn_state_all"
          class="typo-label"
          variant="link"
          @click="mostraPaginaCentrali"
        >{{$t("navbar_dispositivi.all")}}</b-button>
        <b-button
          v-if="this.$store.getters.isCentralized && haIlluminazione()"
          :pressed="btn_state_lighting"
          class="typo-label"
          variant="link"
          @click="mostraPaginaIlluminazione"
        >{{$t("navbar_dispositivi.lighting")}}</b-button>
        <b-button
          v-if="this.$store.getters.isCentralized && haIlluminazione()"
          :pressed="btn_state_emergency"
          class="typo-label"
          variant="link"
          @click="mostraPaginaEmergenza"
        >{{$t("navbar_dispositivi.emergency")}}</b-button>
        <b-button
          v-if="this.$store.getters.isCentralized && haIlluminazione()"
          :pressed="btn_state_sensor"
          class="typo-label"
          variant="link"
          @click="mostraPaginaSensori"
        >{{$t("navbar_dispositivi.sensor")}}</b-button>
        <b-button
          :pressed="btn_state_ble_zones"
          class="typo-label"
          variant="link"
          @click="mostraZoneBluetooth"
        >{{$t("navbar_dispositivi.ble_zones")}}</b-button> 
       <b-button
          v-if="this.$store.getters.isCentralized && haIlluminazione() && $store.state.showDevFeatures == true"
          :pressed="btn_state_collection"
          class="typo-label"
          variant="link"
          @click="mostraPaginaCollection"
        >{{$t("navbar_dispositivi.collection")}}</b-button>
        <b-button
          v-if="$store.state.showDevFeatures == true"
          :pressed="btn_state_qrlamps"
          class="typo-label"
          variant="link"
          @click="mostraPaginaLampadeQr"
        >{{$t("navbar_dispositivi.qrLamps")}}</b-button>
      </nav>
    </show-at>

    <!-- modal per selezionare il tipo di dispositivo, tra 'illuminazione', 'emergenza' e 'sensori' -->
    <!-- <b-modal
      id="modal-device-type"
      hide-header
      hide-footer
      centered
      size="sm"
      body-class="p-0"
      content-class="border-0 shadow-lg"
    > -->
    <b-sidebar
      id="sidebar-device-type"
      :title="$t('navbar_dispositivi.select_type')"
      shadow
      backdrop
      height="auto"
    >
      <div class="px-3 py-2">
        <b-list-group flush>
          <b-list-group-item 
            button 
            @click="selectAndClose('illuminazione')"
            :class="{active: devicesType == 'illuminazione'}"
          >
            {{$t("navbar_dispositivi.lighting")}}
          </b-list-group-item>
          <b-list-group-item 
            button 
            @click="selectAndClose('emergenza')" 
            :class="{active: devicesType == 'emergenza'}"
          >
            {{$t("navbar_dispositivi.emergency")}}
          </b-list-group-item>
          <b-list-group-item 
            button 
            @click="selectAndClose('sensori')" 
            :class="{active: devicesType == 'sensori'}"
          >
            {{$t("navbar_dispositivi.sensor")}}
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-sidebar>
    <!-- </b-modal> -->
  </div>
 
</template>

<script>
import { mapState } from "vuex";
import {showAt, hideAt} from 'vue-breakpoints'
import { Button } from "bootstrap";

export default {
  name: "NavBarDispositivi",
  components: {
    showAt,hideAt
  },
  data() {
    return {
      devicesType: '',
    };
  },
  mounted() {
    console.log("navbar dispositivi mounted, route = ", this.$router.currentRoute);
    let routeDevType = this.$router.currentRoute.params.devicesType;
    console.log("devicesTypes=" + this.devicesType+", routeDevType:"+routeDevType)
    if (this.$router.currentRoute.name == 'Aggregazioni') {
      this.devicesType = 'Aggregazioni';
    } else if (this.$router.currentRoute.name == 'QrLamps') {
      this.devicesType = 'QrLamps';
    } else {
      if (this.devicesType != routeDevType) {
        this.devicesType = routeDevType;
        //this.$forceUpdate();
      }
    }
    
  },
  computed: {
    //property che restituisce il tipo di dispositivo selezionato
    selectedDeviceTypeText() {
      if (this.devicesType == 'illuminazione') return this.$t("navbar_dispositivi.lighting");
      else if (this.devicesType == 'emergenza') return this.$t("navbar_dispositivi.emergency");
      else if (this.devicesType == 'sensori') return this.$t("navbar_dispositivi.sensor");
      else return this.$t("navbar_dispositivi.device_type");
    },

    btn_state_all() {
        return this.$store.getters.isCentralized && this.devicesType == null || this.deviceTypes == '';
    },
    btn_state_emergency() {
      //console.log("currentRoute:",this.$router.currentRoute);
      //if (this.$router.currentRoute.name == "Centrali" && this.devicesTypes == 'emergenza') return true;
      //else return false;
      return this.devicesType == 'emergenza';
    },
    btn_state_lighting() {
      return this.devicesType == 'illuminazione';
    },
    btn_state_sensor() {
      return this.devicesType == 'sensori';
    },
    btn_state_ble_zones() {
      return this.devicesType == 'zoneBluetooth' || (!this.$store.getters.isCentralized && this.devicesType == null || this.deviceTypes == '');
    },
    btn_state_collection() {
      if (this.$router.currentRoute.name == "Aggregazioni") return true;
      else return false;
    },
    btn_state_qrlamps() {
      if (this.$router.currentRoute.name == "QrLamps") return true;
      else return false;
    }

  },
  watch: {
    '$route'() {
        // TODO: react to navigation event.
        // params cotains the current route parameters
        console.log("route changed 2!",this.$route.params);
        this.devicesType = this.$route.params["devicesType"];
        this.$forceUpdate();
    },
  },
  methods: {
    //Funzione che consente di selezionare un tipo di dispositivo e chiudere il modal, viene chiamata al click su una delle voci del modal
    selectAndClose(type) {
      if (type === 'illuminazione') this.mostraPaginaIlluminazione();
      else if (type === 'emergenza') this.mostraPaginaEmergenza();
      else if (type === 'sensori') this.mostraPaginaSensori();

      //chiudo il modal tramite l'ID
      // this.$bvModal.hide('modal-device-type');
      //Chiusura sidebar
      //this.$bvSidebar.hide('sidebar-device-type');
    },
    haIlluminazione() {
      //lasciamo vedere tutte le voci ugualmente...
      
      /*let centrali = this.$store.state.plantUnits;
      if (centrali != null && centrali.length > 0) {
        for (var i=0; i< centrali.length; i++) {
          //console.log("centrale trovata: ", centrali[i]);
          if (centrali[i].cu_type == 'logicafm') return true;
        }
      }
      return false;*/
      return true;
    },
    mostraZoneBluetooth() {
      //evitismo una navigazione ridondante se siamo già nella pagina Zone, verificando i parametri della route
      const parametri = { plantId: this.$store.state.currentPlant.id, devicesType: 'zoneBluetooth' }
      const currentroute = this.$route;
      if (JSON.stringify(currentroute.params) != JSON.stringify(parametri)) {
        this.$router.push({
          name: "Centrali",
          params: parametri
        });
      }
    },
    mostraPaginaCentrali() {
      //evitismo una navigazione ridondante se siamo già nella pagina Zone, verificando i parametri della route
      const parametri = { plantId: this.$store.state.currentPlant.id, devicesType: null }
      const currentroute = this.$route;
      if (JSON.stringify(currentroute.params) != JSON.stringify(parametri)) {
        this.$router.push({
          name: "Centrali",
          params: parametri
        });
      }
    },
    mostraPaginaEmergenza() {
      //evitismo una navigazione ridondante se siamo già nella pagina Zone, verificando i parametri della route
      const parametri = { plantId: this.$store.state.currentPlant.id, devicesType: 'emergenza' }
      const currentroute = this.$route;
      if (JSON.stringify(currentroute.params) != JSON.stringify(parametri)) {
        this.$router.push({
          name: "Centrali",
          params: parametri
        });
      }
    },
    mostraPaginaIlluminazione() {
      //evitismo una navigazione ridondante se siamo già nella pagina Zone, verificando i parametri della route
      const parametri = { plantId: this.$store.state.currentPlant.id, devicesType: 'illuminazione' }
      const currentroute = this.$route;
      if (JSON.stringify(currentroute.params) != JSON.stringify(parametri)) {
        this.$router.push({
          name: "Centrali",
          params: parametri
        });
      }
    },
    mostraPaginaSensori() {
      //evitismo una navigazione ridondante se siamo già nella pagina Zone, verificando i parametri della route
      const parametri = { plantId: this.$store.state.currentPlant.id, devicesType: 'sensori' }
      const currentroute = this.$route;
      if (JSON.stringify(currentroute.params) != JSON.stringify(parametri)) {
        this.$router.push({
          name: "Centrali",
          params: parametri
        });
      }
    },
    mostraPaginaCollection() {
      this.$router.push({
        name: "Aggregazioni",
        params: { pid: this.$store.state.currentPlant.id, devicesType: 'Aggregazioni' }
      });
    },
    mostraPaginaLampadeQr() {
      this.$router.push({
        name: "QrLamps",
        params: { pid: this.$store.state.currentPlant.id, devicesType: 'QrLamps' }
      });
    }
  }
};
</script>

<style scoped>

.btn:focus-visible { 
  outline: 1px dashed #474aff;
  outline-offset: 1px;
}

#modal-device-type .list-group-item {
  cursor: pointer !important;
  user-select: none;
}

#modal-device-type .list-group-item:focus {
  background-color: transparent !important;
  outline: none !important;
  box-shadow: none !important;
}

</style>  